<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12crz6q/tc-custom/9781439633359.jpg?1700065786010" alt="This image is the cover for the book Panama City, Postcard History"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Panama City, Postcard History
      </h1>
      <p class="bookDescription body article font2">
        <p>Panama City began as three 640-acre homesteads in the late 1800s and was incorporated in 1909. The seat of Bay County, this thriving port city of nearly 156,000 is home to Tyndall Air Force Base and the Naval Coastal Systems Center. This volume contains more than 200 vintage postcard views of Panama City from its earliest years through the 1970s. Scenes of neighboring Panama City Beach include early beach institutions like the Hangout at Long Beach Resort, Jenkins Drive In, Mitties Tavern, and Little Birmingham. Those who remember the Fo�C�sle Grille at the Verde Mer Cottages in Laguna Beach deserve a gold star.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        J. D. Weeks
      </h2>
      
      <p class="authorDescription body article">An avid collector of antique postcards, author J. D. Weeks is a retired public health administrator who began visiting Panama City with his parents in the 1940s and developed an interest in local history at an early age. Since then, his three children and nine grandchildren all have enjoyed similar experiences here. Weeks�s book Birmingham in Vintage Postcards was published by Arcadia in 1999.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0fa4c858